"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var queryable_1 = require("./queryable");
var LimitedWebPartManager = (function (_super) {
    __extends(LimitedWebPartManager, _super);
    /**
     * Creates a new instance of the LimitedWebPartManager class
     *
     * @param baseUrl The url or Queryable which forms the parent of this fields collection
     * @param path Optional, if supplied will be appended to the supplied baseUrl
     */
    function LimitedWebPartManager(baseUrl, path) {
        return _super.call(this, baseUrl, path) || this;
    }
    Object.defineProperty(LimitedWebPartManager.prototype, "webparts", {
        /**
         * Gets the set of web part definitions contained by this web part manager
         *
         */
        get: function () {
            return new WebPartDefinitions(this, "webparts");
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Exports a webpart definition
     *
     * @param id the GUID id of the definition to export
     */
    LimitedWebPartManager.prototype.export = function (id) {
        var exporter = new LimitedWebPartManager(this, "ExportWebPart");
        return exporter.post({
            body: JSON.stringify({ webPartId: id }),
        });
    };
    /**
     * Imports a webpart
     *
     * @param xml webpart definition which must be valid XML in the .dwp or .webpart format
     */
    LimitedWebPartManager.prototype.import = function (xml) {
        var importer = new LimitedWebPartManager(this, "ImportWebPart");
        return importer.post({
            body: JSON.stringify({ webPartXml: xml }),
        });
    };
    return LimitedWebPartManager;
}(queryable_1.Queryable));
exports.LimitedWebPartManager = LimitedWebPartManager;
var WebPartDefinitions = (function (_super) {
    __extends(WebPartDefinitions, _super);
    /**
     * Creates a new instance of the WebPartDefinitions class
     *
     * @param baseUrl The url or Queryable which forms the parent of this fields collection
     * @param path Optional, if supplied will be appended to the supplied baseUrl
     */
    function WebPartDefinitions(baseUrl, path) {
        return _super.call(this, baseUrl, path) || this;
    }
    /**
     * Gets a web part definition from the collection by id
     *
     * @param id GUID id of the web part definition to get
     */
    WebPartDefinitions.prototype.getById = function (id) {
        return new WebPartDefinition(this, "getbyid('" + id + "')");
    };
    return WebPartDefinitions;
}(queryable_1.QueryableCollection));
exports.WebPartDefinitions = WebPartDefinitions;
var WebPartDefinition = (function (_super) {
    __extends(WebPartDefinition, _super);
    /**
     * Creates a new instance of the WebPartDefinition class
     *
     * @param baseUrl The url or Queryable which forms the parent of this fields collection
     * @param path Optional, if supplied will be appended to the supplied baseUrl
     */
    function WebPartDefinition(baseUrl, path) {
        return _super.call(this, baseUrl, path) || this;
    }
    Object.defineProperty(WebPartDefinition.prototype, "webpart", {
        /**
         * Gets the webpart information associated with this definition
         */
        get: function () {
            return new WebPart(this);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Removes a webpart from a page, all settings will be lost
     */
    WebPartDefinition.prototype.delete = function () {
        var deleter = new WebPartDefinition(this, "DeleteWebPart");
        return deleter.post();
    };
    return WebPartDefinition;
}(queryable_1.QueryableInstance));
exports.WebPartDefinition = WebPartDefinition;
var WebPart = (function (_super) {
    __extends(WebPart, _super);
    /**
     * Creates a new instance of the WebPart class
     *
     * @param baseUrl The url or Queryable which forms the parent of this fields collection
     * @param path Optional, if supplied will be appended to the supplied baseUrl
     */
    function WebPart(baseUrl, path) {
        if (path === void 0) { path = "webpart"; }
        return _super.call(this, baseUrl, path) || this;
    }
    return WebPart;
}(queryable_1.QueryableInstance));
exports.WebPart = WebPart;



//////////////////
// WEBPACK FOOTER
// ./~/sp-pnp-js/lib/sharepoint/webparts.js
// module id = 34
// module chunks = 0